import { axiosClient } from "@/api/axios";

export function get(query) {
  return axiosClient.get(`your-learning`, query);
}
